export default "__VITE_PUBLIC_ASSET__360c654a__"